import React from "react"
import "./EducationSmall.scss"

import { RaisedButton, CleanButton, GhostButton } from "../Buttons"

import ArrowRight from "../../assets/svg/right-arrow.svg"
import Environment from "../../assets/svg/environment.svg"
import Nae6tukui from "../../assets/images/nae-6tukui.jpg"
import MiskaiPhoto from "../../assets/images/naujiena-miskai-apdovanojimai.jpg"


export default ({ children }) => {
  // return <div className="box-n">{children}</div>
  return (

    <div>

    <div className="block-header-left " style={{marginBottom:"48px"}}>
      <h3 style={{paddingBottom:"8px", marginBottom:"0px"}}>Pasiruošk</h3>
      <p>Čia rasi naudingos informacijos, kuri padės gilinti žinias apie mus supančią aplinką ir geriau pasiruošti egzaminui. </p>
    </div>

    <section class="main--container2">

      <a href={"/naujiena-miskai-2026"}>
        <article className="card">
          <img src={MiskaiPhoto} alt=""/>
          <article className="content">
            <h6>Šiemet nacionaliniame aplinkosaugos egzamine – dėmesys miškų temai</h6>
            <p>
            </p>
          </article>
        </article>
      </a>

      <a target="_blank"
         href={"https://www.lrt.lt/naujienos/lietuvoje/2/2731414/nacionalini-aplinkosaugos-egzamina-lietuviai-islaike-6-tukui"}>
        <article className="card">
          <img src={Nae6tukui} alt=""/>
          <article className="content">
            <h6>Nacionalinį aplinkosaugos egzaminą lietuviai išlaikė 6-tukui</h6>
            <p>
            </p>
          </article>
        </article>
      </a>

      <a target="_blank"
         href={"https://www.lrt.lt/naujienos/gyvenimas/13/2103873/16-metu-mesos-nevalganti-meda-lietuvoje-truksta-suvokimo-kokia-itaka-klimatui-daro-musu-mityba"}>
        <article className="card">
          <img src="https://www.lrt.lt/img/2023/08/17/1569588-190400-393x221.jpg" alt=""/>
          <article className="content">
            <h6>16 metų mėsos nevalganti Meda: Lietuvoje trūksta suvokimo, kokią įtaką klimatui daro mūsų mityba</h6>
            <p>
            </p>
          </article>
        </article>
      </a>





    </section>

      <GhostButton href="/education" >
        Žiūrėti viską
        <img src={ArrowRight} alt="" style={{width : "24px", height : "24px"}}/>
      </GhostButton>

    </div>
  )
}
